import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const linkStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  marginBottom: '1rem',
  color: '#0d9488',
  fontWeight: 500,
  fontSize: '0.9rem',
  textDecoration: 'none',
};

export default function BackToDashboard() {
  const { t, i18n } = useTranslation();
  const arrow = i18n.language === 'ar' ? '→' : '←';

  return (
    <Link to="/dashboard" style={linkStyle} aria-label={t('common.backToDashboard')}>
      <span aria-hidden>{arrow}</span>
      {t('common.backToDashboard')}
    </Link>
  );
}
